import React from 'react';
import { graphql } from 'gatsby';
import LayoutContainer from '../../containers/layout';
import SEO from '../../components/seo';
import TextComponent from '../../components/TextComponent/textComponent';
import { BilateralContainerLayoutStyleListTypes, BiLateralStyleListTypes, TextComponentLayout } from '../../utils/utils';
import BilateralBlock from '../../components/Bilateral/BilateralBlock/bilateralBlock';
import BilateralImage from '../../components/Bilateral/BilateralImage/bilateralImage';
import BilateralContainerLayout from '../../components/Bilateral/BilateralContainerLayout/bilateralContainerLayout';
import getWhoWeArepageData from '../../normalization/who-we-are';
import Timeline from '../../components/Timeline';
import BilateralCardInfo from '../../components/BilateralCardInfo/bilateralCardInfo';
import BilateralCardContainer from '../../components/Bilateral/BilateralCardContainer/bilateralCardContainer';

export const query = graphql`
  query WhoWeAreSitePageQuery {
    site: sanitySiteSettings(_id: { regex: "siteSettings/" }) {
      title
      description
      keywords
    }
  }
`;
const WhoWeAre = (props) => {
  const pageData = getWhoWeArepageData();
  const { dataForTl } = pageData;
  const { data } = props;
  const { site } = data || {};
  console.log(pageData.bilateral2)
  return (
    <LayoutContainer>
      <SEO title={`${site.title} | Who We Are`} description={site.description} keywords={site.keywords} />
      <BilateralContainerLayout layoutStyle={BilateralContainerLayoutStyleListTypes.BILATERALSTYLE2}>
        <div className="container">
          <BilateralBlock layoutStyle={BiLateralStyleListTypes.BILATERALSTYLE1}>
            <TextComponent
              heading="It Started with a Dog"
              description={pageData.someText}
              linksBtn={pageData.links}
              layoutStyle={TextComponentLayout.LEFT}
            />
            <BilateralImage src={pageData.dogImage} />
          </BilateralBlock>

          <BilateralBlock layoutStyle={BiLateralStyleListTypes.BILATERALSTYLE1}>
            <TextComponent
              heading={pageData.bilateral2.textComponent.headline}
              description={pageData.bilateral2.textComponent.description}
              linksBtn={pageData.bilateral2.textComponent.links.data}
              layoutStyle={TextComponentLayout.LEFT}
            />
            <BilateralImage src={pageData.bilateral2.bilateralImage.webUrl} />
          </BilateralBlock>
        </div>
      </BilateralContainerLayout>
      <Timeline data={pageData} />

      <BilateralContainerLayout layoutStyle={BilateralContainerLayoutStyleListTypes.BILATERALSTYLE1}>
        <BilateralCardContainer>
          {dataForTl.map((cardData) => {
            return (
              <BilateralCardInfo
                key={Math.random().toString(36).substring(7)}
                heading={cardData?.heading}
                imageData={cardData?.imageData}
                textHeading={cardData?.textHeading}
                description={cardData?.description}
                linksBtn={cardData?.linksBtn}
                layoutStyle={TextComponentLayout.LEFT}
              />
            );
          })}
        </BilateralCardContainer>
      </BilateralContainerLayout>
    </LayoutContainer>
  );
};
export default WhoWeAre;
